import PropTypes from 'prop-types';
import {FmlxTooltip} from 'fmlx-common-ui';
import './TipsPickupCalibrationResultAndGuide.scss';
import ImageSequence from 'contents/SetupWizard/components/ImageSequence';
import {parseMessage} from 'lib/stringHelper';
import {useDispatch, useSelector} from 'react-redux';
import {TipsPickupSelectors} from 'stores/selectors/headSelectors';
import {useEffect} from 'react';
import {fetchAndSetTipsPickupCalibrationData} from './TipsPickupCalibrationBusiness';

const UNCALIBRATED_A1_OFFSET_STATUS = 'Uncalibrated';

function ColoredCalibrationLabel({text}) {
  const isInvalidValue = text === UNCALIBRATED_A1_OFFSET_STATUS || text === '-';
  return <span className={isInvalidValue ? 'error' : 'positive-green'}>{text}</span>;
}

const pngLocation = (imageName) => `./images/preparation-wizard/${imageName}.png`;

ColoredCalibrationLabel.propTypes = {text: PropTypes.any.isRequired};

function TipsPickupCalibrationResultAndGuide({imgGuideSize}) {
  const dispatch = useDispatch();
  const tipsPickupPosition = useSelector(TipsPickupSelectors.getPosition);
  const calibrationDate = useSelector(TipsPickupSelectors.getLastCalibratedDate);
  const isRecentlyCalibrated = useSelector(TipsPickupSelectors.getIsRecentlyCalibrated);

  const tooltipLabel = parseMessage('tipsPickupCalibration.tooltip.lastCalibrationDate');

  useEffect(() => {
    async function fetchData() {
      await dispatch(fetchAndSetTipsPickupCalibrationData());
    }

    fetchData();
  }, [dispatch]);

  return (
    <div className="tips-pickup-calibration-results">
      <div className="tips-pickup-calibration-results__last-calibrated-info">
        <span className="tips-pickup-calibration-results__last-calibrated-info__item">
          {parseMessage('tipsPickupCalibration.lastCalibration')}
          <span>
            <ColoredCalibrationLabel text={calibrationDate || UNCALIBRATED_A1_OFFSET_STATUS} />
            {isRecentlyCalibrated && (
              <FmlxTooltip placement="bottom" title={tooltipLabel}>
                <span style={{marginLeft: '5px', color: '#FFCA0A'}}>*</span>
              </FmlxTooltip>
            )}
          </span>
        </span>
        <span className="tips-pickup-calibration-results__last-calibrated-info__group-item">
          <span className="tips-pickup-calibration-results__last-calibrated-info__item">
            X:
            <ColoredCalibrationLabel text={tipsPickupPosition?.x} />
          </span>
          <span className="tips-pickup-calibration-results__last-calibrated-info__item">
            Y:
            <ColoredCalibrationLabel text={tipsPickupPosition?.y} />
          </span>
          <span className="tips-pickup-calibration-results__last-calibrated-info__item">
            Z:
            <ColoredCalibrationLabel text={tipsPickupPosition?.z} />
          </span>
        </span>
      </div>
      <div className="tips-pickup-calibration-results__guidance">
        <div className="tips-pickup-calibration-results__guidance__title">
          {parseMessage('tipsPickupCalibration.guidance.title')}
        </div>
        <div className="tips-pickup-calibration-results__guidance__body">
          {parseMessage('tipsPickupCalibration.guidance.text')}
        </div>
        <div className="tips-pickup-calibration-results__guidance__image">
          <ImageSequence
            images={{style: {height: imgGuideSize}, imgPaths: [pngLocation('jig'), pngLocation('jig-on-tray')]}}
          />
        </div>
      </div>
    </div>
  );
}

TipsPickupCalibrationResultAndGuide.propTypes = {
  imgGuideSize: PropTypes.string,
};

TipsPickupCalibrationResultAndGuide.defaultProps = {
  imgGuideSize: '',
};

export default TipsPickupCalibrationResultAndGuide;
